// Tokens visuais extraídos 1:1 de mockups/1g-editor-soap.html. Um só lugar para as
// cores e fontes — os componentes usam estilo inline (como o mockup) para casar o
// pixel sem uma camada de CSS build. NÃO ajustar valores sem revalidar o mockup.

export const cor = {
  bg: '#f2f2f3',
  texto: '#1d1f20',
  muted: '#5d5d60',

  azul: '#5980a6', // acento S/O/P e botão primário
  azulHover: '#597ea3',
  azulActive: '#416180',

  ambarBorda: '#a86a00', // incerteza + campo Avaliação (Regra 3 e 7)
  ambarBg: '#fdf1dc',
  ambarTexto: '#7a4d00',

  verde: '#1c6b40', // estado "Copiado ✓"

  cabecalhoCampo: '#e9e9ea',
  branco: '#fff',

  linha: 'rgba(29,31,32,.16)',
  linhaFraca: 'rgba(29,31,32,.12)',
  linhaForte: 'rgba(29,31,32,.2)',
} as const;

export const fonte = {
  corpo: '"Barlow", system-ui, sans-serif',
  condensada: '"Barlow Condensed", system-ui, sans-serif',
  serif: "Georgia, 'Times New Roman', serif", // texto clínico
  mono: "ui-monospace, 'Courier New', monospace", // códigos, letras S/O/A/P
} as const;

import type { CSSProperties } from 'react';

// Botões — espelham .btn / .btn-primary / .btn-secondary do mockup.
export const btnBase: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  cursor: 'pointer',
  textDecoration: 'none',
  fontFamily: fonte.condensada,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: 1.2,
  color: cor.texto,
  background: 'transparent',
  border: `1px solid ${cor.linha}`,
  borderRadius: 0,
  padding: '6.8px 12.2px',
};

export const btnPrimario: CSSProperties = {
  ...btnBase,
  background: cor.azul,
  color: cor.bg,
  borderColor: cor.azul,
};

export const btnSecundario: CSSProperties = {
  ...btnBase,
  borderColor: cor.linha,
};

export const btnCopiado: CSSProperties = {
  ...btnBase,
  background: cor.verde,
  borderColor: cor.verde,
  color: cor.bg,
};
